import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

interface RoiBarChartProps {
  data: { label: string; value: number }[];
}

/** Flat horizontal bar chart, no growth/entry animation. */
export const RoiBarChart: React.FC<RoiBarChartProps> = ({ data }) => (
  <div style={{ width: '100%', height: Math.max(220, data.length * 44) }}>
    <ResponsiveContainer>
      <BarChart data={data} layout='vertical' margin={{ left: 8, right: 24, top: 4, bottom: 4 }}>
        <CartesianGrid horizontal={false} stroke='var(--color-border)' />
        <XAxis
          type='number'
          tickFormatter={(v: number) => `£${v.toLocaleString('en-GB')}`}
          tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }}
          axisLine={{ stroke: 'var(--color-border)' }}
          tickLine={false}
        />
        <YAxis
          type='category'
          dataKey='label'
          width={170}
          tick={{ fontSize: 12, fill: 'var(--color-foreground)' }}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip
          formatter={(value?: number) => [`£${(value ?? 0).toLocaleString('en-GB')}`, 'Value']}
          contentStyle={{
            fontSize: 12,
            borderRadius: 6,
            border: '1px solid var(--color-border)',
            background: 'var(--color-card)',
          }}
        />
        {/* --chart-primary is the branded chart colour ThemeContext puts on
            :root; --color-primary is a near-white fallback in dark mode. */}
        <Bar dataKey='value' fill='var(--chart-primary, var(--color-primary))' radius={4} isAnimationActive={false} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);
